<template>
  <div class="mt-10">
    <table aria-label="gross table" class="w-full">
        <thead>
            <tr>
            <th id="0">#</th>
            <th class=" uppercase" v-for="(header, index) in headers" :key="index" :id="index">
                <p>{{ header.title }}</p>
            </th>
            </tr>
        </thead>
        <tbody
            v-if="grossEarningsData.length > 0"
            v-for="(item, earningIndex) in grossEarningsData"
            :key="earningIndex"
        >
            <tr
                v-for="(earning, index) in item.payItems"
                :key="index"
                class="text-sm "
                style="height: 48px; background-color: white"
            >
                <td>
                    {{ index + 1 }}
                </td>
                <td>
                    {{ earning.name }}
                </td>
                <td>
                    {{ Capitalize(earning.type) }}
                </td>
                <td>
                    {{ earning.rateType }}
                </td>
                <td>
                    {{ earning.rate }}
                </td>
                <td>
                    {{ earning.amount ? convertToCurrency(earning.amount) : "-" }}
                </td>
            </tr>
        </tbody>
        <tbody
            style="height: 52px; border-spacing: 15px 0;"
            class="mt-4 w-full bg-ghostWhite totalTable"
            v-if="grossEarningsData.length"
        >
            <tr>
                <td class="" />
                <td class="font-bold text-lg  text-darkPurple ">
                    Total
                </td>
                <td class="" />
                <td class="" />
                <td class=" font-bold text-blueCrayola text-lg">
                    {{ totalPercent + "%" }}
                </td>
                <td class="font-bold ">
                    {{ convertToCurrency(totalAmount) }}
                </td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "IndContractorPayInfoTable",
  props: {
    grossEarningsData: {
      type: Array,
      default() {
        return [];
      }
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    totalPercent: {
      type: Number,
      default: 0
    },
    variableTable: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      headers: [
        { title: "pay item" },
        { title: "pay type" },
        { title: "rate type" },
        { title: "rate (%)" },
        { title: "amount(₦)" },
      ]
    };
  },
  watch: {
  },
  methods: {}
};
</script>

<style scoped>
th {
  border: none;
  text-align: left;
  padding: 7px;
  min-height: 60px !important;
}
.totalTable::before {
  content: "";
  display: block;
  height: 24px;
  background-color: white;
  clear: both;
}
</style>